import { render, staticRenderFns } from "./IconsTable.vue?vue&type=template&id=a93475e2&"
import script from "./IconsTable.vue?vue&type=script&lang=js&"
export * from "./IconsTable.vue?vue&type=script&lang=js&"
import style0 from "./IconsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports